var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_24419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40082 16.5016C8.34908 16.6155 8.26433 16.7113 8.15756 16.7765C8.05079 16.8417 7.9269 16.8734 7.80193 16.8674C7.67695 16.8614 7.55665 16.8181 7.45659 16.743C7.35652 16.6679 7.2813 16.5644 7.24066 16.4461L3.15707 3.94064C3.12363 3.83205 3.12043 3.71639 3.14781 3.60612C3.17519 3.49584 3.23211 3.39512 3.31245 3.31477C3.3928 3.23443 3.49352 3.17751 3.6038 3.15013C3.71407 3.12275 3.82973 3.12595 3.93832 3.15939L16.4461 7.24064C16.5645 7.28128 16.6679 7.3565 16.743 7.45656C16.8181 7.55663 16.8614 7.67693 16.8674 7.8019C16.8734 7.92688 16.8417 8.05076 16.7765 8.15754C16.7113 8.26431 16.6155 8.34905 16.5016 8.4008L13.0039 9.92189C12.9105 9.96261 12.8285 10.0256 12.765 10.1052C12.7015 10.1849 12.6584 10.2789 12.6395 10.3791C12.6207 10.4792 12.6266 10.5824 12.6567 10.6798C12.6869 10.7771 12.7404 10.8656 12.8125 10.9375L16.693 14.818C16.8101 14.9352 16.8759 15.0941 16.8759 15.2598C16.8759 15.4255 16.8101 15.5844 16.693 15.7016L15.7032 16.6922C15.586 16.8093 15.4271 16.8751 15.2614 16.8751C15.0957 16.8751 14.9368 16.8093 14.8196 16.6922L10.9375 12.8125C10.8656 12.7404 10.777 12.6869 10.6796 12.6568C10.5823 12.6267 10.479 12.6209 10.3789 12.6398C10.2787 12.6588 10.1847 12.7019 10.1051 12.7655C10.0254 12.8291 9.96256 12.9112 9.92191 13.0047L8.40082 16.5016Z",
    stroke: "#2250FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.25V1.875",
    stroke: "#2250FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.5H1.875",
    stroke: "#2250FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5L10.625 1.25",
    stroke: "#2250FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10L1.25 10.625",
    stroke: "#2250FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_24419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClick);
export default __webpack_public_path__ + "static/media/CursorClick.9fff8b6c059f90aae5349ad9b630cd3d.svg";
export { ForwardRef as ReactComponent };